import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AgrProcessEnv } from '@next/core-lib/environment';

import { provideAppBootstrap, setupRuntimeConfig } from './app/app.bootstrap';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

declare global {
  interface Window {
    AGR_ENV_PROD: AgrProcessEnv;
  }
}

if (environment.PRODUCTION) {
  enableProdMode();
}

setupRuntimeConfig.then(() => {
  bootstrapApplication(AppComponent, {
    providers: provideAppBootstrap(),
  }).catch((err) => console.error(err));
});
